module.exports = __webpack_public_path__ + "static/img/22.aaada7c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/zh/22.png
// module id = 7TgJ
// module chunks = 0